// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwCommandPanel from 'viewmodel/AwCommandPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';

/*
ctx imports
*/

const ctxImportObj = {};

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "actions": {
    "closeAddCommentSubmitRfqPopup": {
      "actionType": "Event",
      "method": "Event",
      "inputData": {
        "events": [{
          "name": "awsidenav.openClose"
        }]
      }
    }
  },
  "onEvent": [{
    "eventId": "submit-rfq.success",
    "action": "closeAddCommentSubmitRfqPopup",
    "cacheEventData": true
  }],
  "data": {
    "closeAnchor": "commandPanelCloseAnchor"
  },
  "i18n": {
    "submitRfq": ["RfqMessages"]
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "rfqid": {
      "type": "string"
    }
  },
  "_viewModelId": "SubmitRfqCommandPanel",
  "_uniqueViewModelId": "SubmitRfqCommandPanel",
  "ctx": {}
};

/*
<aw-command-panel caption="{{i18n.submitRfq}}" anchor="data.closeAnchor">
    <aw-panel-body>
        <des-submit-rfq
        acc-session-id="{{props.accsessionid}}"
        collaborationspace-id="{{props.collaborationspaceid}}"
        rfq-id="{{props.rfqid}}">
    </des-submit-rfq>
    </aw-panel-body>
</aw-command-panel>
*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement(AwCommandPanel, {
    revealAction: actions.reveal,
    anchor: AwParseService.instance("data.closeAnchor")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    updateActiveView: AwParseService.instance("{activeView: data.activeView, dispatch: dispatch }")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    caption: AwParseService.instance("i18n.submitRfq")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement(AwPanelBody, null, /*#__PURE__*/React.createElement("des-submit-rfq", {
    "acc-session-id": AwParseService.instance("props.accsessionid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "collaborationspace-id": AwParseService.instance("props.collaborationspaceid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "rfq-id": AwParseService.instance("props.rfqid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  })));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;